
export const CREATE_INVOICE = "/invoicing/invoices";
export const GET_INVOICES_LIST = "/invoicing/invoices";
export const GET_INVOICE_FILE = "/invoicing/invoices/getFileUrl";
export const RETRY_INVOICE = "/invoicing/invoices/retry";
